import { Button } from 'antd';
import React, { useState } from 'react'
import { downloadClienteAnexo } from '../../api/clientes';
import { DownloadOutlined } from '@ant-design/icons';


interface ButtonProps {
    onClick: React.MouseEvent<HTMLButtonElement>;
    loading: boolean;
    handleLoading: any;
    children: React.ReactNode;
    props: any;
}

export const FsBtnDownload: React.FC<any> = ({ onClick, itemDownload, children, props }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleDownload = () => {
        setIsLoading(true);
        const dados = { ...itemDownload, idCliente: itemDownload.idCliente }
        const response = downloadClienteAnexo(dados);
        response.then((res: any) => {
            const url = window.URL.createObjectURL(new Blob([res]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                `${itemDownload.file_name}`
            );
            document.body.appendChild(link);
            link.click();
            setIsLoading(false);
        })
    };

    return (
        <Button
            {...props}
            loading={isLoading}
            icon={<DownloadOutlined />}
            type="primary"
            onClick={() => {
                handleDownload();
            }}
        >
            {children}
        </Button>
    );
}